import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, ContextualField, IdentifierQuery, IdentifierQueryResultDto, IExtraButton, Miniature } from '../../../../models';
import { ILoggerService } from '../../../../services';
import { IdentifierQueryService } from '../../../../services/data';
import { createIdentifierQueryMiniatures } from './createIdentifierQueryMiniatures';
import { IRootScope } from 'IRootScope';
import { refreshClick } from '../../../../common/events';
import * as Fields from '../../../../common/helpers/contextual';
import { isTokenizable } from '../../../../common/helpers';

class ModernQueriesContextualController implements angular.IComponentController {
    extraButtons: IExtraButton[];
    formController: angular.IFormController;
    isSaving: boolean;
    miniatures: Miniature[] = [];
    properties: ContextualField[];
    queries: IdentifierQuery[] = [];
    selectedItem: IdentifierQuery;

    static $inject = [
        '$rootScope',
        'identifierQueryService',
        'loggerService'
    ];

    constructor(
        private _$rootScope: IRootScope,
        private _identifierQueryService: IdentifierQueryService,
        private _loggerService: ILoggerService
    ) {
    }

    $onInit() {
        this.initMiniatureList();
        this.initializeProperties();
        this.extraButtons = [
            {
                title: 'Refresh',
                icon: 'fa-refresh',
                click: () => this.refresh()
            }
        ];
    }

    onCancel() {
        this.unselect();
    }

    onSave(): angular.IPromise<IdentifierQuery[]> {
        return this._identifierQueryService
            .update(this.selectedItem)
            .then(result => {
                this.selectedItem.isCreating = false;
                this.queries = result.list;
                if (this.queries && this.queries.length > 0) {
                    this.selectedItem = this.queries.find(query => query.guid === this.selectedItem.guid);
                }
                if (result.message) {
                    this._loggerService.logError(result.message);
                } else {
                    this._loggerService.logSuccess('Identifier query successfully saved.');
                }
                this.formController.$setPristine();
                return result.list;
            });
    }

    refresh() {
        this._$rootScope.$broadcast(refreshClick);
    }

    private initializeProperties() {
        const nameField = angular.copy(Fields.Name);
        nameField.isValid = (newName: string) => {
            const isUnique = this.queries.filter(query => query.name === newName && query.guid !== this.selectedItem.guid).length === 0;
            return {
                'duplicate': isUnique
            };
        };
        const querySearch = angular.copy(Fields.QuerySearch);
        querySearch.isValid = (value: string) => {
            const isValid = isTokenizable(value);
            return {
                'invalid': isValid
            };
        };
        this.properties = [
            nameField,
            angular.copy(Fields.ShortComment),
            angular.copy(Fields.AggregationModesMultiSelect),
            angular.copy(Fields.ValueTypesMultiSelect),
            angular.copy(querySearch)
        ];
    }

    private initMiniatureList(): void {
        this.miniatures = createIdentifierQueryMiniatures();
    }

    private unselect() {
        if (this.formController) {
            this.formController.$setPristine();
        }
        this.selectedItem = null;
    }
}

export const wtModernQueriesContextual: ComponentDefinition = {
    componentId: 'wtModernQueriesContextual',
    controller: ModernQueriesContextualController,
    template: require('./modernQueriesContextual.component.html'),
    controllerAs: 'vm',
    bindings: {
        formController: '=',
        queries: '=',
        selectedItem: '='
    }
};